import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Button, Typography } from '@material-ui/core';
import { useAdrBeta } from './BetaProvider';

export default function BetaGate({ children }) {
  const beta = useAdrBeta();
  if (beta.loading) return <Box p={3} role="status">Checking Adverse Reporting beta access…</Box>;
  if (beta.error) return <Box p={3} role="alert"><Typography>{beta.error}</Typography><Button onClick={beta.refresh}>Retry beta access</Button></Box>;
  if (!beta.adrBetaEnabled) return <Redirect to="/profile" />;
  return children;
}
